export const SWIPE_IMAGE =
  "https://res.cloudinary.com/rubics/image/upload/c_crop,h_100,w_100/v1693210663/swipe_vey0o3.gif";
export const FILE_ENDPOINT = "https://filer.rubics.as";
export const PROFILER_API_ENDPOINT = "https://api.profiler.marketing";
